import type { Action } from 'redux'
import type { StreamDefinition, InvokeDefinition } from '../../../signalr/types'
import {
  defaultGetParams as getParams,
  payloadAsParam
} from '../../../signalr/helpers'
import {
  type RestrictedTradesDeleteAction,
  type RestrictedTradesSaveAction,
  getRestrictedTradesSuccess,
  saveRestrictedTradesSuccess,
  saveRestrictedTradesFailure,
  deleteRestrictedTradesSuccess,
  deleteRestrictedTradesFailure
} from './actions'
import type { RestrictedTrades } from './types'

export const fetchRestrictedTradesDefinition: StreamDefinition<
  [],
  RestrictedTrades[],
  Action
> = {
  method: 'GetRestrictedTrades',
  strategy: 'switch',
  getParams,
  mapResponse: getRestrictedTradesSuccess,
  errorAction: 'restrictedtrades.fetchFail',
  cancelOn: ['restrictedtrades.fetchCancel']
}

export const saveRestrictedTradesDefinition: InvokeDefinition<
  [RestrictedTrades],
  number,
  RestrictedTradesSaveAction
> = {
  method: 'SaveRestrictedTrades',
  getParams: payloadAsParam,
  mapResponse: (transactionId, action) =>
    saveRestrictedTradesSuccess(action.payload, transactionId),
  mapError: saveRestrictedTradesFailure
}

export const deleteRestrictedTradesDefinition: InvokeDefinition<
  [RestrictedTrades[]],
  string,
  RestrictedTradesDeleteAction
> = {
  method: 'DeleteRestrictedTrades',
  getParams: payloadAsParam,
  mapResponse: (transactionId, action) =>
    deleteRestrictedTradesSuccess(action.payload, transactionId),
  mapError: deleteRestrictedTradesFailure
}
